import React from 'react';

interface YouTubeEmbedProps {
  /** The YouTube video id (the part after youtu.be/ or watch?v=). */
  id: string;
  /** Accessible iframe title. */
  title: string;
  /** Optional visible heading rendered above the video. */
  label?: string;
}

// Privacy-friendly embed: youtube-nocookie.com defers cookies until playback.
const YouTubeEmbed: React.FC<YouTubeEmbedProps> = ({ id, title, label }) => (
  <div className="mb-[40px]">
    {label && (
      <h3 className="font-display text-[15px] font-bold text-content-primary mt-[20px] mb-[6px]">
        {label}
      </h3>
    )}
    <div className="relative w-full aspect-video rounded-[12px] overflow-hidden border border-surface-hover shadow-[0_2px_12px_rgba(34,211,238,0.08)]">
      <iframe
        className="absolute inset-0 w-full h-full"
        src={`https://www.youtube-nocookie.com/embed/${id}`}
        title={title}
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    </div>
  </div>
);

export default YouTubeEmbed;
